"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypingBubble = void 0;
const react_1 = __importDefault(require("react"));
const TypingContent_1 = require("./TypingContent");
const TypingBubble = () => (react_1.default.createElement("div", { className: "flex mb-2 w-full lg:w-11/12 items-center" },
    react_1.default.createElement("div", { className: "flex relative z-10 items-start typebot-host-bubble" },
        react_1.default.createElement("div", { className: "flex items-center absolute px-4 py-2 rounded-lg bubble-typing z-10", style: {
                width: "4rem",
                height: "2rem",
            } },
            react_1.default.createElement(TypingContent_1.TypingContent, null)))));
exports.TypingBubble = TypingBubble;
//# sourceMappingURL=TypingBubble.js.map